export default __webpack_public_path__ + "static/media/clipboard.bd6aa53e.svg";